import React, { Fragment } from "react";

export default (
  <>
    <path d="M12 10.8A4.8 4.8 0 1 1 16.8 6a4.8 4.8 0 0 1-4.8 4.8zm0-2.22A2.58 2.58 0 1 0 9.42 6 2.57 2.57 0 0 0 12 8.58zm8.22 10.2c.68 1.87-.6 4-3.24 4H7c-2.23 0-3.88-1.65-3.29-3.92v-.12A8.72 8.72 0 0 1 12 13.2a8.72 8.72 0 0 1 8.22 5.58zM7 20.32h10c.83 0 1-.36.92-.68a6.24 6.24 0 0 0-5.92-4 6.25 6.25 0 0 0-5.9 3.92c-.1.49.18.76.9.76z" />
  </>
);
